<template>
  <div class="space-x-1 leading-5 truncate">
    <input
      :id="id"
      :aria-checked="modelValue"
      :checked="modelValue"
      class="border text-blue disabled:opacity-30 text-base md:text-sm shadow-sm rounded-sm border-blue ring-inset focus:ring-0"
      :class="{
        'cursor-wait': loading,
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled && !loading,
      }"
      :disabled="disabled || loading"
      type="checkbox"
      :value="modelValue"
      @input="$emit('update:modelValue', !modelValue)"
    >
    <CarvisSpinner
      v-if="loading"
      class="h-2 absolute opacity-30 -mt-[0.8rem]"
    />
    <slot name="label">
      <label
        class="cursor-pointer"
        :for="id"
        @click.prevent="$emit('update:modelValue', !modelValue)"
      >
        <slot />
      </label>
    </slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  disabled?: boolean
  loading?: boolean
  id: string
  modelValue: boolean
}>()

defineEmits(['update:modelValue'])
</script>
